import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Periodontitis } from "@/components/landing/Periodontitis";
import { LaserBento } from "@/components/landing/LaserBento";
import { Protocol } from "@/components/landing/Protocol";
import { ZeroFear } from "@/components/landing/ZeroFear";
import { Doctor } from "@/components/landing/Doctor";
import { Team } from "@/components/landing/Team";
import { Faq } from "@/components/landing/Faq";
import { Booking } from "@/components/landing/Booking";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFab } from "@/components/landing/WhatsAppFab";
import AppointmentPage from "@/pages/AppointmentPage";
import CheckinPage from "@/pages/CheckinPage";
import AdminPage from "@/pages/admin/AdminPage";
import AuthCallback from "@/pages/admin/AuthCallback";
import BlogIndex from "@/pages/blog/BlogIndex";
import ArticlePage from "@/pages/blog/ArticlePage";
import FirstVisitPage from "@/pages/firstvisit/FirstVisitPage";
import GbtPage from "@/pages/gbt/GbtPage";
import BookPerioPage from "@/pages/booking/BookPerioPage";
import QuizPage from "@/pages/quiz/QuizPage";
import FearPage from "@/pages/fear/FearPage";
import TownPage from "@/pages/town/TownPage";
import NewsletterPage from "@/pages/NewsletterPage";
import FlyerPage from "@/pages/flyer/FlyerPage";
import FinancingPage from "@/pages/financing/FinancingPage";
import { FinancingTeaser } from "@/components/landing/FinancingTeaser";
import { ChatWidget } from "@/components/chat/ChatWidget";
import { MobileActionBar } from "@/components/landing/MobileActionBar";
import { BOOK_PERIO_PATH, FINANCING_PATH } from "@/components/landing/data";
import { BlogTeaser } from "@/components/landing/BlogTeaser";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { useGaPageView, useContactClickTracking } from "@/lib/analytics";
import { Reviews } from "@/components/landing/Reviews";
import { GbtBadge } from "@/components/landing/GbtBadge";
import { Location } from "@/components/landing/Location";
import { scrollToId } from "@/components/landing/Reveal";

function Landing() {
  const [symptoms, setSymptoms] = useState([]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    const hash = window.location.hash.slice(1);
    const t = hash && !hash.includes("=") ? setTimeout(() => scrollToId(hash), 700) : null;
    return () => { clearTimeout(t); cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="App grain">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <GbtBadge />
        <Periodontitis symptoms={symptoms} setSymptoms={setSymptoms} />
        <LaserBento />
        <Protocol />
        <BeforeAfter />
        <Reviews />
        <ZeroFear />
        <Doctor />
        <Team />
        <Faq />
        <FinancingTeaser />
        <BlogTeaser />
        <Location />
        <Booking symptoms={symptoms} setSymptoms={setSymptoms} />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  useGaPageView(location);
  useContactClickTracking();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const showChat = !/^\/(area-riservata|visita|come-stai|volantino)/.test(location.pathname);
  return (
    <>
    {showChat && <ChatWidget />}
    {showChat && <MobileActionBar />}
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path={BOOK_PERIO_PATH} element={<BookPerioPage />} />
      <Route path="/visita/:token" element={<AppointmentPage />} />
      <Route path="/come-stai/:token" element={<CheckinPage />} />
      <Route path="/area-riservata" element={<AdminPage />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<ArticlePage />} />
      <Route path="/prima-visita" element={<FirstVisitPage />} />
      <Route path="/igiene-gbt" element={<GbtPage />} />
      <Route path="/test-gengive" element={<QuizPage />} />
      <Route path="/paura-del-dentista" element={<FearPage />} />
      <Route path="/parodontite/:town" element={<TownPage />} />
      <Route path="/newsletter/:action/:token" element={<NewsletterPage />} />
      <Route path="/volantino" element={<FlyerPage />} />
      <Route path={FINANCING_PATH} element={<FinancingPage />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { background: "#FCFBF7", border: "1px solid #D5DFD3", color: "#1B3B28", fontFamily: "Plus Jakarta Sans" } }} />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
